import { Injector, ProviderToken } from '@angular/core';

/**
 * Allows for retrieving singletons using `AppInjector.get(MyService)` (whereas
 * `ReflectiveInjector.resolveAndCreate(MyService)` would create a new instance
 * of the service).
 */
let appInjector: Injector;

/**
 * Helper to set the exported {@link AppInjector}
 */
export const setAppInjector = (injector: Injector): void => {
  appInjector = injector;
};

/**
 * Provides an Injectable in a larger context than https://angular.io/api/core/inject
 */
export const inject = <T>(token: ProviderToken<T>): T => appInjector.get(token);
